import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'

export function useIsEditingUser() {
  return useSelector<RootState, boolean>(isEditingUserSelector)
}

export function isEditingUserSelector({
  socketServer,
  user
}: Pick<RootState, 'socketServer' | 'user'>): boolean {
  const editingUsers = socketServer.roomState?.botState?.editingUsers ?? {}
  return user.info.id !== undefined && !!editingUsers[user.info.id]
}
